import React, { Component } from "react";
import { FormGroup, Col, Row } from "react-bootstrap";
import { InputFormSpocket } from "shared_components";
import "./style.css";

class NewPasswordForm extends Component {
  render() {
    return (
      <FormGroup>
        <Row>
          <Col md={12} className="New-password__title">
            <p>Please set a password before logging out!</p>
          </Col>
          <Col md={12} className="New-password__input">
            <InputFormSpocket
              name="password"
              label="New Password"
              typeInput="password"
              onChange={e => this.props.handleInputChanged(e)}
            />
          </Col>
          <Col md={12} className="New-password__input">
            <InputFormSpocket
              name="confirm_password"
              label="Confirm New Password"
              typeInput="password"
              onChange={e => this.props.handleInputChanged(e)}
            />
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

export default NewPasswordForm;



// WEBPACK FOOTER //
// ./src/components/_Shared/NewPasswordForm/index.js